import { Injectable } from '@angular/core';
import { isDocumentAvailable } from '../../util';
var containerFactory = function (type) { return function (children, classes, styles) {
    if (classes === void 0) { classes = ""; }
    if (styles === void 0) { styles = {}; }
    var container = document.createElement(type);
    container.className = classes;
    Object.keys(styles).map(function (key) { return container.style[key] = styles[key]; });
    if (typeof children === 'string') {
        container.innerHTML = children || '';
    }
    else {
        (children || []).forEach(function (child) { return container.appendChild(child); });
    }
    return container;
}; };
var div = containerFactory('div');
var ul = containerFactory('ul');
var li = containerFactory('li');
var td = containerFactory('td');
var th = containerFactory('th');
var tr = containerFactory('tr');
var tbody = containerFactory('tbody');
var thead = containerFactory('thead');
var table = containerFactory('table');
var monthHeader = function () { return (div("\n            <span class=\"k-calendar-title\">March 2017</span>\n            <span class=\"k-calendar-today\">TODAY</span>\n        ", 'k-calendar-header')); };
var monthWeekHeader = function () { return (table([
    thead([
        tr([th('MO')])
    ])
], 'k-calendar-weekdays')); };
var monthContent = function () { return (table([
    tbody([
        tr([th('1')]),
        tr([td('1')]),
        tr([td('1')]),
        tr([td('1')]),
        tr([td('1')]),
        tr([td('1')]),
        tr([td('1')])
    ])
])); };
var scrollable = function (children) { return div(children, 'k-content k-scrollable'); };
var monthScrollable = function () { return scrollable([monthContent()]); };
var monthView = function () { return (div([
    monthHeader(),
    monthWeekHeader(),
    monthScrollable()
], 'k-calendar-monthview')); };
var listItem = function () { return li('<span>FEB</span>'); };
var list = function () { return ul([listItem()]); };
var navigationScrollable = function () { return scrollable([list()]); };
var navigation = function () { return div([navigationScrollable()], 'k-calendar-navigation'); };
var calendar = function () {
    if (!isDocumentAvailable()) {
        return null;
    }
    var cal = div([navigation(), monthView()], 'k-widget k-calendar k-calendar-infinite', { left: '-10000px' });
    return div([cal], 'k-temp-calendar');
};
var CALENDAR_ELEMENT = calendar();
/**
 * @hidden
 */
var DOMService = (function () {
    function DOMService() {
    }
    DOMService.prototype.calendarHeight = function () {
        return this.computedHeight(function (el) { return el; });
    };
    DOMService.prototype.monthScrollableContentHeight = function () {
        return this.computedHeight(function (el) { return el.querySelector('.k-calendar-monthview').querySelector('.k-scrollable'); });
    };
    DOMService.prototype.monthViewHeight = function () {
        return this.computedHeight(function (el) { return el.querySelector('tbody'); });
    };
    DOMService.prototype.monthHeaderHeight = function () {
        return this.computedHeight(function (el) { return el.querySelector('tbody').children[0]; });
    };
    DOMService.prototype.navigationItemHeight = function () {
        return this.computedHeight(function (el) { return el.querySelector('li'); });
    };
    DOMService.prototype.computedHeight = function (selector) {
        if (!isDocumentAvailable()) {
            return 0;
        }
        var rootElement = document.body.appendChild(CALENDAR_ELEMENT);
        var element = selector(rootElement.children[0]);
        var height = parseFloat(window.getComputedStyle(element).height) || element.offsetHeight;
        document.body.removeChild(rootElement);
        return height;
    };
    return DOMService;
}());
export { DOMService };
DOMService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DOMService.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dateinputs/dist/es/calendar/services/dom.service.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/calendar/services/dom.service.js
// module chunks = 3